import React from "react";
import { Icon as AntIcon } from "@ant-design/compatible";
import { IconProps as AntIconProps } from "@ant-design/compatible/lib/icon";

export interface IIconProps extends AntIconProps {}

export const Icon = (props: AntIconProps) => {
  return <AntIcon {...props} />;
};
